<template>
    <section>
        <div class="row justify-content-end">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'material/index' }">
                                Bahan Ajar
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            Mata Pelajaran Bahan Ajar
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row">
            <div class="col mb-3">
                <h3>
                    {{ grade.name }}
                </h3>
            </div>
        </div>
        <div class="row">
            <div class="col px-4">
                <div class="row">
                    <div class="col-xl-4 col-md-6 col-12 mb-4" v-for="gradeSubject in gradeSubjects">
                        <div class="card border-danger position-relative">
                            <div class="card border-danger position-absolute">
                                <div class="card-body py-2 px-4">
                                    <h4 class="font-weight-bold mb-0 text-danger text-truncate text-center">{{ gradeSubject.subject.name }}</h4>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col small py-3" v-html="gradeSubject.description">
                                    </div>
                                </div>
                                <div class="row justify-content-end">
                                    <div class="col-auto ml-auto">
                                        <router-link v-bind:to="{name: 'material/view', params: {gradeID: gradeSubject.gradeID, gradeSubjectID: gradeSubject.id}}" class="btn btn-sm btn-danger px-4 pull-right">
                                            Masuk
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "MaterialSubject",
        data() {
            return {
                grade: {},
                gradeSubjects: []
            };
        },
        created() {
            this.axios.all([
                this.axios.get(process.env.API_URL + '/grade/' + this.$route.params.gradeID),
                this.axios.get(process.env.API_URL + '/grade-subject', {params: {gradeID: this.$route.params.gradeID}})
            ]).then(this.axios.spread(function (responseGrade, responseGradeSubject) {
                this.grade = responseGrade.data.data;
                this.gradeSubjects = responseGradeSubject.data.data;
            }.bind(this)));
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/material/Subject.vue